import React, {Component} from "react";

import {Dialog, DialogTitle, AppBar, Toolbar, Typography, IconButton} from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";

class CloseableDialog extends Component {
    constructor(props, context) {
        super(props, context);
        }

    onClick = () => {
        var {onClose} = this.props;
        onClose();
        }

    render = () => {
        var {open, onClose, dialogTitle, children} = this.props;

        return <Dialog open={open} onClose={onClose}>
            <AppBar position="static">
                <Toolbar color="inherit">
                    <Typography variant="h6" style={{flexGrow: 1}}>{dialogTitle}</Typography>
                    <IconButton color="inherit" onClick={this.onClick}>
                        <ClearIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            {children}
            </Dialog>;
        }
    }
export default CloseableDialog;